import { useContext } from "react";

import { AppSettingsContext } from "../AppSettingsProvider";

export const useAppSetting = (key, defaultValue) => {
  const { appSettings } = useContext(AppSettingsContext);

  return appSettings?.[key] ?? defaultValue;
};
